// Must run before any firebase/app code loads — suppresses IndexedDB + auth noise in console
import './suppressConsole';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/overflow-fix.css';
/* Font Awesome CSS deferred to reduce main bundle size and unused CSS; loads after first paint */
import App from './App';
import reportWebVitals from './reportWebVitals';

// Block invalid Google Fonts request for Arial (system font) to prevent 400 errors from third-party widgets
const originalFetch = window.fetch;
window.fetch = function (...args: Parameters<typeof fetch>) {
  const url = typeof args[0] === 'string' ? args[0] : (args[0] as Request)?.url ?? '';
  if (url.includes('fonts.googleapis.com') && (url.includes('family=Arial') || url.includes('family=arial'))) {
    return Promise.reject(new Error('Arial is a system font'));
  }
  return originalFetch.apply(this, args);
};

const originalXHROpen = XMLHttpRequest.prototype.open;
XMLHttpRequest.prototype.open = function (
  method: string,
  url: string | URL,
  async?: boolean,
  username?: string | null,
  password?: string | null
) {
  if (typeof url === 'string' && url.includes('fonts.googleapis.com') && (url.includes('family=Arial') || url.includes('family=arial'))) {
    this.send = () => {};
    return;
  }
  return originalXHROpen.call(this, method, url, async ?? true, username, password);
};

// Suppress third-party widget errors (e.g. SociableKit eBay widget null style)
const originalOnError = window.onerror;
window.onerror = function (message, source, lineno, colno, error) {
  if (typeof message === 'string' && (
    message.includes("reading 'payload'") ||
    message.includes('idb-set') ||
    message.includes('Cannot read properties of null') ||
    message.includes("reading 'style'") ||
    (typeof source === 'string' && source.includes('widget.js') && message.includes('style'))
  )) {
    return true;
  }
  return originalOnError ? originalOnError(message, source, lineno, colno, error) : false;
};

window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason;
  const msg = reason?.message ?? String(reason ?? '');
  const name = reason?.name ?? '';
  if (
    name === 'QuotaExceededError' ||
    (typeof msg === 'string' && (msg.includes('QuotaExceededError') || msg.toLowerCase().includes('quota')))
  ) {
    event.preventDefault();
  }
  if (typeof msg === 'string' && msg.includes('Cannot read properties of null') && msg.includes('style')) {
    event.preventDefault();
  }
  // Firebase SDK / minified core when callable fails or IndexedDB fails (reading 'payload')
  if (
    typeof msg === 'string' &&
    (msg.includes("reading 'payload'") ||
      msg.includes('idb-set') ||
      msg.includes('Error thrown when writing to IndexedDB'))
  ) {
    event.preventDefault();
  }
  // Stripe blocked by ad-blocker (r.stripe.com) — FetchError uncaught in stripe.js
  if (
    name === 'FetchError' ||
    (typeof msg === 'string' &&
      (msg.includes('r.stripe.com') ||
        msg.includes('ERR_BLOCKED_BY_CLIENT') ||
        (msg.includes('FetchError') && msg.includes('Failed to fetch'))))
  ) {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
